"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const CategoryTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/CategoryTag.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const lucide_vue_next_1 = require("lucide-vue-next");
let BestRecommendation = class BestRecommendation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.expandedRecommendations = [];
    }
    isExpandedRecommendation(p) {
        if (this.expandedRecommendations.find((s) => s === p.slug))
            return true;
        return false;
    }
    toggleRecommendation(p) {
        if (this.isExpandedRecommendation(p)) {
            this.expandedRecommendations = this.expandedRecommendations.filter((s) => s !== p.slug);
        }
        else {
            this.expandedRecommendations.push(p.slug);
        }
    }
    updateActiveRecommendation(prod) {
        this.$emit('updateActiveRecommendation', prod);
    }
    isActiveRecommendation(p) {
        if (this.activeRecommendation) {
            if (this.activeRecommendation.slug === p.slug)
                return true;
        }
        return false;
    }
    polishAncestors(p) {
        const ancestors = this.recomms.findMyAncestors(p.slug, false).reverse().slice(0, -1);
        const separator = ' - ';
        const ancestorsStr = ancestors.reduce((accum, anc, index) => {
            if (index === ancestors.length - 1) {
                return accum + anc.name;
            }
            return accum + anc.name + separator;
        }, '');
        return ancestorsStr;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new Recommendations_1.RecommendationSet([]) })
], BestRecommendation.prototype, "recomms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], BestRecommendation.prototype, "activeRecommendation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], BestRecommendation.prototype, "hasInteraction", void 0);
BestRecommendation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            CategoryTag: CategoryTag_vue_1.default,
            Rating: bmk_ui_framework_1.Rating,
            RecommendationBadge: bmk_ui_framework_1.RecommendationBadge,
            Button: bmk_ui_framework_1.Button,
            ChevronRight: lucide_vue_next_1.ChevronRight,
            ChevronDown: lucide_vue_next_1.ChevronDown
        },
    })
], BestRecommendation);
exports.default = BestRecommendation;
